import { IconProps } from "@/common/contracts/icon.contracts";

export const Brenger = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13840_36357)">
        <path
          d="M5.28231 13.38C4.97923 13.3447 5.0044 13.1029 5.0044 12.8953C5.00021 9.20958 4.99706 5.52384 5.0044 1.83702C5.00545 1.23147 5.28021 0.988603 5.89579 0.984324C6.48935 0.980044 7.08291 0.984324 7.67646 0.984324C8.45145 0.984324 8.66852 1.18974 8.67377 1.99643C8.68425 3.63442 8.67796 5.27241 8.67901 6.91147C8.67901 7.00027 8.66748 7.09121 8.67901 7.17788C8.70733 7.41646 8.56156 7.74919 8.77444 7.86795C8.94538 7.96317 9.15197 7.68179 9.33968 7.56624C12.9545 5.33019 17.8257 7.48279 18.8062 11.7548C18.8859 12.1004 18.9436 12.4513 18.9855 12.8033C19.0149 13.0505 19.0338 13.3211 18.6867 13.3768C18.6489 13.3211 18.6174 13.3297 18.5912 13.3864C17.7711 13.3939 16.9511 13.3864 16.132 13.4153C15.7252 13.4303 15.5899 13.2441 15.5301 12.8622C15.313 11.4628 14.6649 10.3672 13.2649 9.9478C11.2777 9.35295 8.97369 10.0056 8.51856 12.7766C8.44096 13.2495 8.27946 13.4485 7.78343 13.4185C6.98328 13.3704 6.17998 13.3928 5.37774 13.3853C5.35047 13.3276 5.31901 13.3201 5.28231 13.3768V13.38Z"
          fill="currentColor"
        />
        <path
          d="M6.77687 16.2653C7.84549 16.0374 8.47995 16.3209 8.90152 17.5053C9.40174 18.9122 10.9297 19.6151 12.4136 19.4728C13.7685 19.3434 15.051 18.2617 15.4244 16.8709C15.5481 16.4108 15.7463 16.23 16.2182 16.2546C16.9313 16.2921 17.6486 16.2771 18.3638 16.2589C18.819 16.2471 18.9784 16.4087 18.928 16.8944C18.6459 19.6226 16.3692 22.1561 13.5902 22.8012C9.60204 23.7267 5.69568 20.9995 5.09058 16.8751C5.03186 16.4729 5.14302 16.2546 5.57298 16.2642C5.97463 16.2728 6.37523 16.2664 6.77687 16.2664V16.2653Z"
          fill="currentColor"
        />
        <path
          d="M5.28231 13.38C5.31901 13.3233 5.35063 13.3306 5.37789 13.3884L5.32861 13.3991L5.28231 13.38Z"
          fill="currentColor"
        />
        <path
          d="M18.5912 13.3864C18.6174 13.3297 18.6489 13.3211 18.6867 13.3768L18.6406 13.3969L18.5912 13.3864Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_13840_36357">
          <rect width="24.0001" height="23.9995" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
